import React from 'react';

function Loader() {
    return (
        <div className="transition-loader">
            <div className="transition-loader-inner">
                <label/>
                <label/>
                <label/>
                <label/>
                <label/>
                <label/>
            </div>
        </div>
    )
}

export default Loader;